"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var PREFIX = 'KeyInsightsPopup';
var classes = {
    PopUpText: "".concat(PREFIX, "-PopUpText"),
    sideText: "".concat(PREFIX, "-sideText"),
    companyAvatar: "".concat(PREFIX, "-companyAvatar"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.PopUpText)] = {
            fontWeight: theme.typography.fontWeightMedium,
            marginBottom: 0,
            lineHeight: '1.75rem',
        },
        _b[".".concat(classes.sideText)] = {
            fontWeight: theme.typography.fontWeightLight,
            color: theme.palette.text.secondary,
        },
        _b[".".concat(classes.companyAvatar)] = {
            height: 16,
            width: 16,
            borderRadius: 0,
            margin: theme.spacing(0, 0.5),
        },
        _b);
});
var KeyInsightsPopup = function (_a) {
    var allRenewals = _a.allRenewals, allNewAndCancelledApps = _a.allNewAndCancelledApps;
    return ((0, jsx_runtime_1.jsx)(Root, { children: (allRenewals === null || allRenewals === void 0 ? void 0 : allRenewals.map(function (renewal) { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, { size: "sm", brand: renewal }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ className: classes.PopUpText, level: 2, ml: 1 }, { children: [renewal.name, (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.sideText }, { children: " - " })), (0, jsx_runtime_1.jsx)(Money_1.default, { amount: renewal.amount }), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.sideText }, { children: " due in the next three months." }))] }))] }), renewal.id)); }))
            || (allNewAndCancelledApps === null || allNewAndCancelledApps === void 0 ? void 0 : allNewAndCancelledApps.map(function (app) { return (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { size: "sm", brand: app, fontWeight: "medium" }, app.id); })) }));
};
exports.default = KeyInsightsPopup;
